import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';
import MuiGrid from '@mui/material/Grid';
import { darkBlue } from '@cpg-its/ads.constants.colors';
const StyledLoadingCircle = styled(CircularProgress)({
    color: darkBlue,
});
export const LoadingCircleComponent = ({ justify = 'center', size = 'medium', testId = undefined, }) => {
    const determineJustification = (() => {
        if (justify === 'left') {
            return 'flex-start';
        }
        if (justify === 'right') {
            return 'flex-end';
        }
        return 'center';
    })();
    const determineSize = (() => {
        if (size === 'small') {
            return 15;
        }
        if (size === 'large') {
            return 60;
        }
        return 40;
    })();
    return (_jsx(MuiGrid, { container: true, "data-testid": testId, justifyContent: determineJustification, children: _jsx(StyledLoadingCircle, { size: determineSize }) }));
};
export default LoadingCircleComponent;
//# sourceMappingURL=loading-circle.js.map